import { IModel, ModelRecord, Model } from './Model';
import { defaultTo } from 'lodash';

export interface ITemplateTypeModel extends IModel {
  templateTypeId: number;
  name: string;
  sortOrder: number;
}

export class TemplateTypeModel
  extends Model
  implements ModelRecord<ITemplateTypeModel>
{
  templateTypeId: number;
  name: string;
  sortOrder: number;

  constructor(params?: Partial<ITemplateTypeModel>) {
    super(params);
    this.templateTypeId = defaultTo(params?.templateTypeId, 0);
    this.name = defaultTo(params?.name, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
  }
}
